import { useEffect, useState } from 'react';

import { getGenders } from '../api/services/Riders';

type Gender = { label: string; value: string };

export const useGenders = () => {
  const [genders, setGenders] = useState<Gender[]>([]);

  useEffect(() => {
    const abortController = new AbortController();

    getGenders(abortController.signal)
      .then((result) => {
        if (result.type === 'success') {
          result.data.genders && setGenders(result.data.genders);
        }
      })
      .catch(() => null);

    return () => abortController.abort();
  }, []);

  const getLabelByValue = (value?: string) => {
    if (!value) {
      return '';
    }
    const genderMatch = genders.find((gender) => gender.value === value);

    return genderMatch?.label || '';
  };

  return { genders, getLabelByValue };
};
